export const stickyHeaderOnScroll = () => {
  if(document.querySelector('.header-wrapper')) {
    const body = document.body;
    const headerWrapper = document.querySelector('.header-wrapper');
    let didScroll;
    let lastScrollTop = 0;
    let delta = 5;
    let headerHeight = document.querySelector('.header-wrapper').offsetHeight;

    window.addEventListener('scroll', () => {
      didScroll = true;
    });

    setInterval(function() {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    function hasScrolled() {
      let st = window.scrollY;
      
      // Make sure they scroll more than delta
      if(Math.abs(lastScrollTop - st) <= delta)
          return;
      
      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > headerHeight){
          // Scroll Down
          headerWrapper.classList.remove('nav-down');
          headerWrapper.classList.add('nav-up');
      } else {
          // Scroll Up
          if(st + window.innerHeight < body.offsetHeight) {
              headerWrapper.classList.remove('nav-up');
              headerWrapper.classList.add('nav-down');
          }
      }
      
      lastScrollTop = st;
    }
    
    if(window.scrollY > 5) {
      headerWrapper.classList.add('header-wrapper--sticky');
    } else {
      headerWrapper.classList.remove('header-wrapper--sticky');
    }

    window.addEventListener('scroll', () => {
      if(window.scrollY > 5) {
        headerWrapper.classList.add('header-wrapper--sticky');
      } else {
        headerWrapper.classList.remove('header-wrapper--sticky');
      }
    });
  }
}